/** Falas por slide. Teca ensina, Nexo aponta o hábito, Vaza tenta um atalho diferente. */
export const CAST = {
  'escudo-estelar:1': {
    teca: 'Teca: O caderno da padaria não é papel da loja. É vida de gente. Vem, eu te levo.',
    nexo: 'Nexo: Ana, Carla e Rico já mexem nisso hoje. Este curso é o escudo deles.',
    vaza: 'Vaza: Vinte minutos? Eu só preciso de um caderno aberto e um café.',
  },
  'escudo-estelar:2': {
    teca: 'Teca: Tela aberta é porta aberta. A Vaza não hackeia: ela entra no que a gente esquece.',
    nexo: 'Nexo: Rico foi ao banheiro sem bloquear. Um minuto bastou para a lista aparecer.',
    vaza: 'Vaza: Não precisei de senha. Precisei de um monitor ligado e ninguém na cadeira.',
  },
  'escudo-estelar:3': {
    teca: 'Teca: Se dá para saber que o pedido é da Maria, já é dado pessoal. CPF não é o único jeito.',
    nexo: 'Nexo: Telefone + pedido do João já identificam. Não espera o documento.',
    vaza: 'Vaza: Adoro quando vocês dizem “é só o número”. Número mais nome sou eu no corredor.',
  },
  'escudo-estelar:4': {
    teca: 'Teca: Mandar, imprimir, anotar, apagar: tudo isso é tratar. Interno não é cofre.',
    nexo: 'Nexo: Print no grupo da loja já é tratamento. Descreve o problema, não a tela.',
    vaza: 'Vaza: Me encaminha no Slack “só pra galera ver”. Eu viajo de graça.',
  },
  'escudo-estelar:5': {
    teca: 'Teca: O dono do dado é a pessoa. A padaria usa. A Altec, no sistema, opera. Ninguém dona a Maria.',
    nexo: 'Nexo: Se pedirem “me apaga”, encaminha. Quem decide não é o caixa.',
    vaza: 'Vaza: Adoro gerente que fala “o dado é nosso”. Aí eu visto o crachá da loja.',
  },
  'escudo-estelar:6': {
    teca: 'Teca: Quatro ideias seguram o dia: só o necessário, motivo certo, cuidado, dá para provar.',
    nexo: 'Nexo: Delivery precisa de endereço. RG no cadastro é peso e risco.',
    vaza: 'Vaza: “Por via das dúvidas a gente guarda tudo.” Essa frase é o meu almoço.',
  },
  'escudo-estelar:7': {
    teca: 'Teca: Três hábitos: bloqueia a tela, não manda dado no grupo, não leva planilha na mochila.',
    nexo: 'Nexo: Windows+L, dois segundos. O turno troca; o seu escudo não.',
    vaza: 'Vaza: Pendrive na mochila é o meu Uber. Obrigada pela carona.',
  },
  'escudo-estelar:8': {
    teca: 'Teca: Identifica = pessoal. Mexer = tratar. Dono = a pessoa. Tela bloqueada. Guarda assim.',
    nexo: 'Nexo: Se o colega novo perguntar o que é LGPD, você já responde sem o Google.',
    vaza: 'Vaza: Recap é chato. Por isso eu ataco na pressa, não na revisão.',
  },
  'escudo-estelar:9': {
    teca: 'Teca: Telefone + pedido identificam o João. Não precisa de CPF. Marca com calma.',
    nexo: 'Nexo: Lê as três. A certa é a que a Teca ensinou, não a mais curta.',
    vaza: 'Vaza: Chuta “telefone é da loja”. Eu torço pelo chute.',
  },
  'escudo-estelar:10': {
    teca: 'Teca: Print no Slack da loja é tratamento. O grupo não é cofre.',
    nexo: 'Nexo: Interno ainda é lugar. Gente entra e sai do canal.',
    vaza: 'Vaza: “É só conversa.” Conversas viram print. Prints viram eu.',
  },
  'escudo-estelar:11': {
    teca: 'Teca: Consentimento é uma chave entre dez. Nota com CPF não espera cookie no totem.',
    nexo: 'Nexo: NFC-e é obrigação legal. Não mistura com aceite de marketing.',
    vaza: 'Vaza: Desliga o CPF na nota “porque a LGPD mandou”. Caos bonito. Eu gosto.',
  },
  'escudo-estelar:12': {
    teca: 'Teca: Obrigação, contrato, interesse com cuidado. “A empresa quis” não é chave.',
    nexo: 'Nexo: Endereço no delivery é contrato. Celular de quem só atravessou a loja, não.',
    vaza: 'Vaza: Marketing pedindo a base toda “por via das dúvidas”. Me chama de sócia.',
  },
  'escudo-estelar:13': {
    teca: 'Teca: Proteger a vida existe. Mesmo assim o canal é o da operação, não o WhatsApp da família.',
    nexo: 'Nexo: Alergia grave vai no sistema da loja. Não no grupo da equipe.',
    vaza: 'Vaza: Emergência no grupo pessoal. Todo mundo vê. Eu também.',
  },
  'escudo-estelar:14': {
    teca: 'Teca: Não inventa base. Não clica aceite pelos outros. Fila não assina.',
    nexo: 'Nexo: Gerente pedindo “um jeito no totem”: não. Chama quem decide o fluxo.',
    vaza: 'Vaza: Caixa marcando aceite para destravar a fila. Eu fico na fila do tesouro.',
  },
  'escudo-estelar:15': {
    teca: 'Teca: Menos dado, menos eu… digo, menos Vaza. Campo extra precisa de motivo.',
    nexo: 'Nexo: “Fica legal no BI” ainda não é necessidade. Pergunta de novo.',
    vaza: 'Vaza: Campo RG “para um dia”. Um dia sou eu no relatório.',
  },
  'escudo-estelar:16': {
    teca: 'Teca: Dez chaves. Consentimento é uma. Só o necessário. Você já tem a frase.',
    nexo: 'Nexo: Marketing pediu a base? Responde: chave certa, dado mínimo.',
    vaza: 'Vaza: Recap de novo. Enquanto isso o CSV já foi no e-mail.',
  },
  'escudo-estelar:17': {
    teca: 'Teca: NFC-e com CPF é obrigação legal. Cookie é outra conversa.',
    nexo: 'Nexo: Não misture nota e totem. A Teca já separou as chaves.',
    vaza: 'Vaza: Marca “precisa de aceite”. A fila trava e a nota some. Diversão.',
  },
  'escudo-estelar:18': {
    teca: 'Teca: “Por via das dúvidas” não abre cadeado. Motivo de verdade ou não pega.',
    nexo: 'Nexo: Celular de quem só passou na loja não é contrato.',
    vaza: 'Vaza: Lead, lead, lead. Eu coleciono lead que ninguém pediu.',
  },
  'escudo-estelar:19': {
    teca: 'Teca: A pessoa pode pedir para ver, corrigir, apagar o excesso. Direito, não favor.',
    nexo: 'Nexo: Pedido no Instagram vale. Anota hora e encaminha.',
    vaza: 'Vaza: Discute o direito no comentário público. Espetáculo. Eu vendo ingresso.',
  },
  'escudo-estelar:20': {
    teca: 'Teca: Você não apaga sozinho. Encaminha ao Encarregado. Confirma que chegou.',
    nexo: 'Nexo: Prestativo é encaminhar rápido. Mexer no cadastro é furo.',
    vaza: 'Vaza: Caixa “bonzinho” apagando tudo agora. Depois a nota precisa existir. Caos.',
  },
  'escudo-estelar:21': {
    teca: 'Teca: Às vezes apaga. Às vezes a lei manda guardar a nota. Quem decide é o fluxo.',
    nexo: 'Nexo: “Vou ver com o time certo” é resposta honesta. Use.',
    vaza: 'Vaza: Apaga a NFC-e no feeling. Auditoria depois é a minha sobremesa.',
  },
  'escudo-estelar:22': {
    teca: 'Teca: Máquina sozinha decidiu? Não fecha a porta com “foi o robô”. Encaminha revisão.',
    nexo: 'Nexo: “Vou pedir revisão humana.” Essa frase cabe no totem.',
    vaza: 'Vaza: “Foi o algoritmo.” A pessoa vai embora. Eu fico com o cadastro travado.',
  },
  'escudo-estelar:23': {
    teca: 'Teca: Número desconhecido pedindo extrato: identidade primeiro. Não anexa.',
    nexo: 'Nexo: Nem os últimos 7 dias. Encaminha. Educação não é arquivo.',
    vaza: 'Vaza: “Sou o João, me manda tudo.” Fantasia barata. Funciona demais.',
  },
  'escudo-estelar:24': {
    teca: 'Teca: Recebe, não mexe, encaminha, confirma. Quatro passos. Cabe no almoço.',
    nexo: 'Nexo: Pedido vale de WhatsApp, caixa ou Instagram. O canal não anula o direito.',
    vaza: 'Vaza: Enquanto vocês recapitulam, alguém já mandou o PDF no privado.',
  },
  'escudo-estelar:25': {
    teca: 'Teca: “Me apaga de tudo agora” no WhatsApp do caixa: encaminha. Não apaga sozinho.',
    nexo: 'Nexo: Anota o pedido. O fluxo oficial mexe no dado.',
    vaza: 'Vaza: Apaga na hora para ficar bem. Eu fico com o furo e o sorriso.',
  },
  'escudo-estelar:26': {
    teca: 'Teca: Extrato para número estranho: não. Identidade primeiro.',
    nexo: 'Nexo: “Só 7 dias” ainda é dado na mão errada.',
    vaza: 'Vaza: Peço educado. Vocês mandam. Eu agradeço o anexo.',
  },
  'escudo-estelar:27': {
    teca: 'Teca: Marca o que identifica gente. Coxinha campeã, sozinha, não identifica.',
    nexo: 'Nexo: Nome, telefone, foto com CPF. A coxinha é distração.',
    vaza: 'Vaza: Marca tudo, inclusive o sabor. Confusão me alimenta.',
  },
  'escudo-estelar:28': {
    teca: 'Teca: Cinco frases. Se você diz no almoço, o básico cumpriu.',
    nexo: 'Nexo: Não faça o Cofre hoje. Espaço ajuda a lembrar.',
    vaza: 'Vaza: Três cursos num dia. Cérebro mole. Eu adoro mole.',
  },
  'escudo-estelar:29': {
    teca: 'Teca: Bloqueia. Não manda no grupo. Não leva planilha. Encaminha pedido. Bolso.',
    nexo: 'Nexo: Se só uma coisa ficar: bloqueia a tela.',
    vaza: 'Vaza: Certificado na parede e tela aberta. Eu leio os dois.',
  },
  'escudo-estelar:30': {
    teca: 'Teca: Escudo no peito. Prova interna, não diploma da ANPD. Descansa.',
    nexo: 'Nexo: Guarda o hábito, não o PNG. A Vaza continua no café.',
    vaza: 'Vaza: Parabéns. Eu volto no primeiro post-it. Até já.',
  },

  'cofre-quantico:1': {
    teca: 'Teca: Agora sobe o nível: saúde, face, senha, 3 dias úteis. Cofre não abre com a chave do escudo.',
    nexo: 'Nexo: Post-it no monitor. A Vaza não hackeia: a gente entrega a chave.',
    vaza: 'Vaza: Senha amarela no vidro. Meu crachá sem foto.',
  },
  'cofre-quantico:2': {
    teca: 'Teca: Apagar a mensagem no Slack não recolhe a senha. Alarme, não borracha.',
    nexo: 'Nexo: 2 fatores e gerenciador. Cadeado pessoal, agora.',
    vaza: 'Vaza: “Apaguei em 10 segundos.” O índice já copiou. Beijo.',
  },
  'cofre-quantico:3': {
    teca: 'Teca: Sensível é lista legal: saúde, biometria, raça, religião… Salário é grave, mas outro tipo.',
    nexo: 'Nexo: Face ou saúde no projeto: Encarregado antes. Não “liga para ver”.',
    vaza: 'Vaza: Catraca com face “só para o refrigerante”. Biometria de graça.',
  },
  'cofre-quantico:4': {
    teca: 'Teca: Alergia pode ser saúde. Cozinha precisa saber no canal da operação.',
    nexo: 'Nexo: Sistema da loja, não WhatsApp pessoal do turno.',
    vaza: 'Vaza: Ficha da criança no grupo da família da equipe. Eu sento à mesa.',
  },
  'cofre-quantico:5': {
    teca: 'Teca: Senha, token, SMS: descreve o erro, não cola a chave. Troca e avisa.',
    nexo: 'Nexo: Homolog com gente de verdade ainda é cofre.',
    vaza: 'Vaza: Print da tela “pro colega ver o erro”. A chave veio no print.',
  },
  'cofre-quantico:6': {
    teca: 'Teca: Need-to-know: só quem a função pede. Curiosidade não é perfil.',
    nexo: 'Nexo: Base de produção para debug? Não. Teste sem gente de verdade.',
    vaza: 'Vaza: “Me manda a base para reproduzir o bug.” Meu download favorito.',
  },
  'cofre-quantico:7': {
    teca: 'Teca: Gerenciador, tela, 2 fatores, avisa acidente. Quatro cadeados.',
    nexo: 'Nexo: Turno da noite desligando 2 fatores “porque atrasa”: abre o cofre.',
    vaza: 'Vaza: Login rápido, cadeado no chão. Eu não tenho pressa. Vocês têm.',
  },
  'cofre-quantico:8': {
    teca: 'Teca: Tipo legal, chave do cofre, need-to-know, alarme. Recap do cofre 1.',
    nexo: 'Nexo: Próximas telas cobram alergia no grupo e senha no Slack.',
    vaza: 'Vaza: Recap. Eu já estou no canal aberto com o CSV.',
  },
  'cofre-quantico:9': {
    teca: 'Teca: Alergia no WhatsApp pessoal? Canal errado. Operação, não família.',
    nexo: 'Nexo: A cozinha precisa saber. O grupo da família, não.',
    vaza: 'Vaza: “A cozinha precisa.” Eu concordo. Me coloca no grupo.',
  },
  'cofre-quantico:10': {
    teca: 'Teca: Senha no Slack: avisa segurança e Encarregado. Apagar não recolhe.',
    nexo: 'Nexo: Sem vergonha. Vergonha é esconder.',
    vaza: 'Vaza: Esconde que colou. Eu ganho três dias de vantagem.',
  },
  'cofre-quantico:11': {
    teca: 'Teca: RIPD é o caderno de risco. Você acende a luz. Não precisa redigir.',
    nexo: 'Nexo: Face, score, saúde: “isso pede RIPD” antes do go-live.',
    vaza: 'Vaza: Go-live sexta, RIPD nunca. Meu feriado.',
  },
  'cofre-quantico:12': {
    teca: 'Teca: Teste com gente real já é tratamento. Mural de aceite não segura face.',
    nexo: 'Nexo: Catraca na sexta sem Encarregado é incidente com hora marcada.',
    vaza: 'Vaza: “Só um teste.” Teste com a padaria inteira. Delícia.',
  },
  'cofre-quantico:13': {
    teca: 'Teca: Encarregado é canal, não bode expiatório. A empresa continua responsável.',
    nexo: 'Nexo: “Quero o DPO.” Encaminha o canal. Você não vira DPO no balcão.',
    vaza: 'Vaza: “O DPO assume a multa.” Mentira útil. Eu espalho.',
  },
  'cofre-quantico:14': {
    teca: 'Teca: Segurança é acesso, log, backup, gente treinada. Badge no LinkedIn não é.',
    nexo: 'Nexo: Este curso é evidência. Leva o hábito, não o selo.',
    vaza: 'Vaza: Meme de cadeado no Slack. Política fake. Eu passo reto.',
  },
  'cofre-quantico:15': {
    teca: 'Teca: Altec sem atalho de pequeno porte. Prazo cheio, dever cheio.',
    nexo: 'Nexo: “LGPD é para multinacional” é lenda. A lei vale aqui.',
    vaza: 'Vaza: “Somos pequenininhos.” Enquanto isso o CSV tem 8 mil nomes.',
  },
  'cofre-quantico:16': {
    teca: 'Teca: RIPD, Encarregado, medida de verdade, sem atalho. Face: luz acesa.',
    nexo: 'Nexo: Perguntas: catraca com face; DPO tira a culpa?',
    vaza: 'Vaza: Recap 2. Eu já liguei a câmera no estoque.',
  },
  'cofre-quantico:17': {
    teca: 'Teca: Face no estoque é biometria. Encarregado antes. Mural não segura.',
    nexo: 'Nexo: Não liga para ver se funciona. Para.',
    vaza: 'Vaza: Aceite no mural da copa. Arte contemporânea. Eu exposito.',
  },
  'cofre-quantico:18': {
    teca: 'Teca: Ter Encarregado não come a multa da empresa. Ele é canal.',
    nexo: 'Nexo: Conformidade é do agente. Resolução 18 diz isso.',
    vaza: 'Vaza: Empurra a culpa no DPO. A casa relaxa. Eu almoço.',
  },
  'cofre-quantico:19': {
    teca: 'Teca: Incidente é evento confirmado com dado de gente em risco. Não é todo bug.',
    nexo: 'Nexo: Na dúvida, avisa. Quem classifica é o time, não o feeling.',
    vaza: 'Vaza: “É só um bug.” CSV de 8 mil no canal aberto. Só um bug, claro.',
  },
  'cofre-quantico:20': {
    teca: 'Teca: 3 dias úteis para ANPD e titular. Sexta 18h também conta. Você avisa agora.',
    nexo: 'Nexo: Contém o arquivo. Não leva o CSV para casa.',
    vaza: 'Vaza: “Investigar no fim de semana.” Meu piquenique com 8 mil CPFs.',
  },
  'cofre-quantico:21': {
    teca: 'Teca: Contém, não espalha, avisa, não entrevista. Recado descreve o buraco.',
    nexo: 'Nexo: Sem print da base no aviso. Tesouro não se anexa.',
    vaza: 'Vaza: “Prova no print.” Vocês me reenviam o tesouro. Obrigada.',
  },
  'cofre-quantico:22': {
    teca: 'Teca: Slack aberto, notebook sumiu, Drive pessoal, API trocada: alarme.',
    nexo: 'Nexo: Homolog com cliente real é produção com outro nome.',
    vaza: 'Vaza: Backup no Gmail pessoal. Eu tenho a chave da casa de vocês.',
  },
  'cofre-quantico:23': {
    teca: 'Teca: Tentativa bloqueada se registra. O relógio começa na confirmação.',
    nexo: 'Nexo: Scan às 3h bloqueado ≠ CSV no canal. Só o segundo dispara o cofre.',
    vaza: 'Vaza: Espera a imprensa para começar. Aí o prazo já morreu.',
  },
  'cofre-quantico:24': {
    teca: 'Teca: Confirmado + dado + risco. 3 dias. Avisa agora. Não viraliza.',
    nexo: 'Nexo: Prova de campo: CSV sexta 18h. Você já sabe a primeira ação.',
    vaza: 'Vaza: Viral no grupo “para todo mundo ficar esperto”. Segundo vazamento.',
  },
  'cofre-quantico:25': {
    teca: 'Teca: CSV no canal aberto: contém e avisa agora. Não espera segunda.',
    nexo: 'Nexo: Não baixa para casa. Levar o tesouro piora o buraco.',
    vaza: 'Vaza: “Segunda a gente vê.” Eu viajo o fim de semana inteiro.',
  },
  'cofre-quantico:26': {
    teca: 'Teca: ANPD se fala pelo fluxo oficial. Você aciona. Não vira porta-voz.',
    nexo: 'Nexo: Gmail pessoal não é canal da Agência.',
    vaza: 'Vaza: Porta-voz no celular. Eu assino a carta com o nome de vocês.',
  },
  'cofre-quantico:27': {
    teca: 'Teca: Recado mínimo: o quê, quando, tipo, quantas. Sem print da base.',
    nexo: 'Nexo: Descreve o buraco. Não reenvia o tesouro.',
    vaza: 'Vaza: Marca o print “para provar”. Eu ganho cópia extra.',
  },
  'cofre-quantico:28': {
    teca: 'Teca: Sensível, senha, RIPD, Encarregado, 3 dias. Cofre fechado na cabeça.',
    nexo: 'Nexo: Rede Nebulosa não é hoje. Deixa descansar.',
    vaza: 'Vaza: Cofre trancado, nebula aberta. Eu troco de porta.',
  },
  'cofre-quantico:29': {
    teca: 'Teca: 2 fatores. Sem credencial no chat. Sem saúde no WhatsApp pessoal.',
    nexo: 'Nexo: Face ou saúde: Encarregado antes. Vazou: alarme.',
    vaza: 'Vaza: Poster de cadeado e senha no Slack. Eu escolho o Slack.',
  },
  'cofre-quantico:30': {
    teca: 'Teca: Cofre trancado. Prova interna. A nebula espera — não hoje.',
    nexo: 'Nexo: Recert em um ano. Hábito todo dia.',
    vaza: 'Vaza: Até a nebula. Levo um CSV na mala.',
  },

  'rede-nebulosa:1': {
    teca: 'Teca: A rede move. Cada pulo é tratamento. Nuvem fora tem pedágio. Menor pesa.',
    nexo: 'Nexo: Planilha no e-mail pessoal, Drive de fornecedor, grupo. Três planetas.',
    vaza: 'Vaza: Não invadi. Vocês me convidaram no Gmail.',
  },
  'rede-nebulosa:2': {
    teca: 'Teca: Cinco sim antes de exportar: preciso, quem, Brasil, contrato, apago depois.',
    nexo: 'Nexo: Faltou um sim, não exporta. Educado e firme.',
    vaza: 'Vaza: Grupo com quem já saiu da empresa. Eu ainda estou lá. Oi.',
  },
  'rede-nebulosa:3': {
    teca: 'Teca: Compartilhar é tratar. Teste não usa a base de produção.',
    nexo: 'Nexo: Tirar o CPF e deixar nome+telefone+endereço ainda identifica.',
    vaza: 'Vaza: “A base toda para testar a integração.” Meu ambiente de homolog favorito.',
  },
  'rede-nebulosa:4': {
    teca: 'Teca: Operador trata no contrato. Dado de cliente não é dataset interno.',
    nexo: 'Nexo: Produto novo com ticket real: Encarregado antes do experimento.',
    vaza: 'Vaza: Treinar modelo com a padaria inteira. Eu sou o dataset.',
  },
  'rede-nebulosa:5': {
    teca: 'Teca: CSV no e-mail, Gmail pessoal, grupo com ex-colega: três convites.',
    nexo: 'Nexo: Limpar grupo é higiene. Não é fofoca de RH.',
    vaza: 'Vaza: Grupo “desde 2019”. Eu sou veterana. A planilha da semana cai aqui.',
  },
  'rede-nebulosa:6': {
    teca: 'Teca: Nuvem fora do Brasil é transferência. Jurídico antes do cartão.',
    nexo: 'Nexo: “Está na AWS” não é automaticamente ok. Pedágio da nebula.',
    vaza: 'Vaza: SaaS bonito nos EUA, lista colada. Eu mudo de país de graça.',
  },
  'rede-nebulosa:7': {
    teca: 'Teca: Preciso? Quem? Brasil? Contrato? Apago? Cinco. Cabe no ímã.',
    nexo: 'Nexo: Parceiro de tráfego sem os cinco sim: não. Protege 12 mil de uma vez.',
    vaza: 'Vaza: “É só para o tráfego.” Tráfego sou eu com a lista no colo.',
  },
  'rede-nebulosa:8': {
    teca: 'Teca: Compartilhar, contrato, e-mail pessoal não, nuvem tem regra, cinco sim.',
    nexo: 'Nexo: Próximas: base de produção para teste; SaaS nos EUA.',
    vaza: 'Vaza: Recap da nebula. O CSV já fez as malas.',
  },
  'rede-nebulosa:9': {
    teca: 'Teca: Integração não se testa com a padaria inteira. Dado mínimo, contrato.',
    nexo: 'Nexo: Ambiente sem gente de verdade. Ou fatia mascarada.',
    vaza: 'Vaza: Parceiro bravo. Vocês mandam a base. Eu fico amiga do parceiro.',
  },
  'rede-nebulosa:10': {
    teca: 'Teca: SaaS nos EUA: para. Jurídico / Encarregado olha cláusula.',
    nexo: 'Nexo: Logo bonito não paga pedágio.',
    vaza: 'Vaza: Cadastra o cartão primeiro. Depois a gente vê. Clássico.',
  },
  'rede-nebulosa:11': {
    teca: 'Teca: Decisão de máquina tem revisão humana. Perfil também é tratamento.',
    nexo: 'Nexo: “Vou pedir revisão.” Nunca “foi o robô”.',
    vaza: 'Vaza: Score escondido no canto. A pessoa nem sabe que eu a classifiquei.',
  },
  'rede-nebulosa:12': {
    teca: 'Teca: “Cliente chato” no ticket, replicado no marketing, já é perfil ruim.',
    nexo: 'Nexo: Se não explica para a pessoa, talvez o campo não devesse existir.',
    vaza: 'Vaza: Campo livre de xingamento. Eu arquivo. Depois vira campanha.',
  },
  'rede-nebulosa:13': {
    teca: 'Teca: Ticket real em IA pública é compartilhar com quem a casa não contratou.',
    nexo: 'Nexo: Ferramenta liberada ou dado fictício. Prompt mágico não é contrato.',
    vaza: 'Vaza: “Não treine com isso” no prompt. Fofo. Eu treino mesmo assim.',
  },
  'rede-nebulosa:14': {
    teca: 'Teca: Menor: extra. Sem responsável, sem exposição. A ANPD já mostrou que multa isso.',
    nexo: 'Nexo: Foto da festa do João de 7 anos no Instagram da loja: tira. Avise.',
    vaza: 'Vaza: Crachá da turma visível no post. Eu não preciso de nome. Tenho a cara.',
  },
  'rede-nebulosa:15': {
    teca: 'Teca: Não expõe menor. Não perfila por esporte. Produto com criança: Encarregado.',
    nexo: 'Nexo: Campo de aniversário no clube infantil não é fofo. É extra.',
    vaza: 'Vaza: “Só mais um campo.” Campo de criança. Meu extra favorito.',
  },
  'rede-nebulosa:16': {
    teca: 'Teca: Revisão, perfil, IA pública não, menor extra, Encarregado na dúvida.',
    nexo: 'Nexo: Perguntas: “foi o robô”; 50 tickets na IA pública.',
    vaza: 'Vaza: Recap 2. Eu já colei os tickets no chat.',
  },
  'rede-nebulosa:17': {
    teca: 'Teca: Cadastro bloqueado pelo sistema: revisão humana. Porta aberta.',
    nexo: 'Nexo: Não inventa motivo para a pessoa sair.',
    vaza: 'Vaza: “Foi o robô, não tem jeito.” Porta fechada. Eu fico do lado de cá.',
  },
  'rede-nebulosa:18': {
    teca: 'Teca: 50 tickets reais na IA pública não é treino. É pulo.',
    nexo: 'Nexo: Dado fictício. Ou ferramenta da casa.',
    vaza: 'Vaza: “É só treino.” Treino com nome e telefone. Me formo rápido.',
  },
  'rede-nebulosa:19': {
    teca: 'Teca: 12 mil, menor no meio, e-mail pessoal, servidor fora. Você é o alarme, não o porta-voz.',
    nexo: 'Nexo: Respira. Não reenvia o CSV para “entender melhor”.',
    vaza: 'Vaza: Entender melhor = me copiar de novo. Pode mandar.',
  },
  'rede-nebulosa:20': {
    teca: 'Teca: Avisa, não reenvia, conta o caminho, para o fornecedor. Relógio já corre.',
    nexo: 'Nexo: Não avisa 12 mil pelo Gmail. Isso é o segundo vazamento.',
    vaza: 'Vaza: “Para ser rápido.” Rápido sou eu no Gmail de vocês.',
  },
  'rede-nebulosa:21': {
    teca: 'Teca: Multa existe: até 2% no Brasil, teto R$ 50 mi por infração. Sem lenda, sem pânico.',
    nexo: 'Nexo: Conhece o número. Não ameaça o colega com ele.',
    vaza: 'Vaza: “A ANPD nunca multa.” Eu espalho essa. Relaxa a casa.',
  },
  'rede-nebulosa:22': {
    teca: 'Teca: TikTok, 1ª instância, cabe recurso. Não é a conta da Altec. Menor pesa. Ponto.',
    nexo: 'Nexo: Corrige o grupo se viralizar o valor como se fosse nosso.',
    vaza: 'Vaza: “Vamos quebrar.” Pânico no grupo. Ninguém avisa o Encarregado.',
  },
  'rede-nebulosa:23': {
    teca: 'Teca: Who, when, what, pass. Prova interna. Recert em 12 meses. Hábito > badge.',
    nexo: 'Nexo: Você é uma linha nessa prova. Leva o hábito para o turno.',
    vaza: 'Vaza: Ranking de badge no Slack. Enquanto isso a tela continua aberta.',
  },
  'rede-nebulosa:24': {
    teca: 'Teca: Avisa, não espalha, teto por infração, menor pesa, prova não é diploma ANPD.',
    nexo: 'Nexo: Última prova: Gmail para 12 mil; número da multa.',
    vaza: 'Vaza: Recap final. Eu ainda estou no Drive do fornecedor.',
  },
  'rede-nebulosa:25': {
    teca: 'Teca: Avisar 12 mil pelo Gmail pessoal: segundo vazamento. Fluxo oficial.',
    nexo: 'Nexo: Encarregado conduz a fala. Você conduz o alarme interno.',
    vaza: 'Vaza: Gmail em massa. 12 mil convites com o meu nome no CC.',
  },
  'rede-nebulosa:26': {
    teca: 'Teca: 2% / R$ 50 mi por infração. A ANPD multa. Não só se tiver morto.',
    nexo: 'Nexo: Art. 52. Sem lenda. Sem pânico inventado.',
    vaza: 'Vaza: “Só multa se tiver morto.” Essa mentira me dá férias.',
  },
  'rede-nebulosa:27': {
    teca: 'Teca: Quatro passos: avisar, não reenviar, contar, parar o fornecedor. Sem megafone.',
    nexo: 'Nexo: De fora: postar no grupo, Gmail, esperar a imprensa.',
    vaza: 'Vaza: Posta no grupo da loja. Megafone. Eu danço.',
  },
  'rede-nebulosa:28': {
    teca: 'Teca: Escudo, cofre, nebula. Três missões. Um cartão de bolso.',
    nexo: 'Nexo: Daqui a um ano, recert. Até lá, não entrega a planilha.',
    vaza: 'Vaza: Três certificados e uma tela aberta. Eu leio a tela.',
  },
  'rede-nebulosa:29': {
    teca: 'Teca: Tela, grupo, IA pública, base toda, pedido, menor, Encarregado. Sete linhas.',
    nexo: 'Nexo: Se esquecer o resto, estas sete seguram o turno.',
    vaza: 'Vaza: Sete linhas no bolso, CSV no Drive. Adivinha quem eu visito.',
  },
  'rede-nebulosa:30': {
    teca: 'Teca: Missão completa. Prova interna. Obrigada por tratar gente como gente.',
    nexo: 'Nexo: Recert em um ano. Até lá, bloqueia a tela. Eu fico de olho.',
    vaza: 'Vaza: Até a próxima porta aberta. Não se esqueçam de mim. Eu não esqueço vocês.',
  },
};
